module.exports = __webpack_public_path__ + "static/img/slide_11.91721e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/slider/slide_11.png
// module id = Qm4s
// module chunks = 0